<template>
  <div class="shop-grid-list">
    <div class="shop-products">
      <div
        v-if="showTitle"
        class="shop-products_top mini-tab-title underline pink"
      >
        <!-- 18/09/2026: titulo a esquerda e "Exibindo x a y de z" a direita, na mesma linha -->
        <div class="d-flex align-items-end justify-content-between">
          <h2
            class="title"
            v-text="title"
          ></h2>
          <span
            v-if="exibindo"
            class="custom-exibindo-info custom-exibindo-titulo"
            v-text="exibindo"
          ></span>
        </div>
        <div class="row align-items-center">
          <div class="col-12 col-xl-8">
            <div
              v-if="showListViewType"
              class="product-option"
            >
              <div class="product-filter">
              </div>
              <div class="view-method">
                <p
                  id="grid-view"
                  class="active"
                >
                  <i class="fas fa-th-large"></i>
                </p>
                <p id="list-view">
                  <i class="fas fa-list"></i>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="displayEmptyDataRow"
        class="shop-products_bottom"
      >
        <div class="grid-list-loading">
          <div
            class="d-inline-block"
            v-html="noDataTemplate"
          ></div>
        </div>
      </div>
      <div class="shop-products_bottom">
        <div class="row no-gutters-sm">
          <div
            v-for="(item, index) in tableData"
            :key="index"
            class="col-6 col-md-3 cursor-pointer"
          >
            <quick-view ref="quick"></quick-view>
            <div
              class="product grid-view"
              v-on:click="checkClick(item.slug, index)"
            >
                <div class="col-md-12 col-sm-6 p-0 box-informacoes-validas">
                <div class="float-left">
                  <div
                    v-if="item.tipo_beneficio === 'F'"
                    class="icon_tipo_beneficio"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="22pt"
                      height="22pt"
                      viewBox="0 0 25 25"
                      version="1.1"
                    >
                      <g id="surface1">
                        <path d="M 23.25 11.296875 L 22.601562 8.707031 C 22.78125 8.667969 22.914062 8.511719 22.914062 8.324219 L 22.914062 7.90625 C 22.914062 7 22.175781 6.261719 21.269531 6.261719 L 18.320312 6.261719 L 18.320312 5.402344 C 18.320312 4.957031 17.957031 4.59375 17.511719 4.59375 L 2.480469 4.59375 C 2.03125 4.59375 1.671875 4.957031 1.671875 5.402344 L 1.671875 12.5 C 1.671875 12.714844 1.84375 12.890625 2.0625 12.890625 C 2.277344 12.890625 2.453125 12.714844 2.453125 12.5 L 2.453125 5.402344 C 2.453125 5.386719 2.464844 5.375 2.480469 5.375 L 17.511719 5.375 C 17.523438 5.375 17.535156 5.386719 17.535156 5.402344 L 17.535156 12.5 C 17.535156 12.714844 17.710938 12.890625 17.929688 12.890625 C 18.144531 12.890625 18.320312 12.714844 18.320312 12.5 L 18.320312 12.054688 L 22.9375 12.054688 C 23.507812 12.058594 23.988281 12.429688 24.15625 12.945312 L 22.9375 12.945312 C 22.722656 12.945312 22.546875 13.117188 22.546875 13.335938 L 22.546875 14.171875 C 22.546875 14.847656 23.097656 15.398438 23.773438 15.398438 L 24.21875 15.398438 L 24.21875 17.117188 L 23.195312 17.117188 C 22.855469 16.148438 21.933594 15.449219 20.851562 15.449219 C 19.765625 15.449219 18.84375 16.148438 18.507812 17.117188 L 18.320312 17.117188 L 18.320312 14.171875 C 18.320312 13.953125 18.144531 13.777344 17.929688 13.777344 C 17.710938 13.777344 17.535156 13.953125 17.535156 14.171875 L 17.535156 17.117188 L 9.414062 17.117188 C 9.078125 16.148438 8.15625 15.449219 7.070312 15.449219 C 5.988281 15.449219 5.066406 16.148438 4.730469 17.117188 L 2.480469 17.117188 C 2.464844 17.117188 2.453125 17.105469 2.453125 17.09375 L 2.453125 16.230469 L 4.148438 16.230469 C 4.367188 16.230469 4.539062 16.054688 4.539062 15.839844 C 4.539062 15.625 4.367188 15.449219 4.148438 15.449219 L 0.390625 15.449219 C 0.175781 15.449219 0 15.625 0 15.839844 C 0 16.054688 0.175781 16.230469 0.390625 16.230469 L 1.671875 16.230469 L 1.671875 17.09375 C 1.671875 17.539062 2.03125 17.902344 2.480469 17.902344 L 4.59375 17.902344 C 4.59375 17.910156 4.59375 17.917969 4.59375 17.929688 C 4.59375 19.292969 5.703125 20.40625 7.070312 20.40625 C 8.4375 20.40625 9.550781 19.292969 9.550781 17.929688 C 9.550781 17.917969 9.550781 17.910156 9.550781 17.902344 L 18.371094 17.902344 C 18.371094 17.910156 18.371094 17.917969 18.371094 17.929688 C 18.371094 19.292969 19.484375 20.40625 20.851562 20.40625 C 22.21875 20.40625 23.328125 19.292969 23.328125 17.929688 C 23.328125 17.917969 23.328125 17.910156 23.328125 17.902344 L 24.609375 17.902344 C 24.824219 17.902344 25 17.726562 25 17.511719 L 25 13.335938 C 25 12.304688 24.238281 11.449219 23.25 11.296875 Z M 18.320312 7.046875 L 21.269531 7.046875 C 21.742188 7.046875 22.128906 7.433594 22.128906 7.90625 L 22.128906 7.933594 L 18.320312 7.933594 Z M 18.320312 11.273438 L 18.320312 8.714844 L 21.796875 8.714844 L 22.4375 11.273438 Z M 7.070312 19.625 C 6.136719 19.625 5.375 18.863281 5.375 17.929688 C 5.375 16.992188 6.136719 16.230469 7.070312 16.230469 C 8.007812 16.230469 8.769531 16.992188 8.769531 17.929688 C 8.769531 18.863281 8.007812 19.625 7.070312 19.625 Z M 20.851562 19.625 C 19.914062 19.625 19.15625 18.863281 19.15625 17.929688 C 19.15625 16.992188 19.914062 16.230469 20.851562 16.230469 C 21.785156 16.230469 22.546875 16.992188 22.546875 17.929688 C 22.546875 18.863281 21.785156 19.625 20.851562 19.625 Z M 24.21875 14.613281 L 23.773438 14.613281 C 23.527344 14.613281 23.328125 14.414062 23.328125 14.171875 L 23.328125 13.726562 L 24.21875 13.726562 Z M 24.21875 14.613281 " />
                        <path d="M 7.070312 17.117188 C 6.625 17.117188 6.261719 17.480469 6.261719 17.929688 C 6.261719 18.375 6.625 18.738281 7.070312 18.738281 C 7.519531 18.738281 7.882812 18.375 7.882812 17.929688 C 7.882812 17.480469 7.519531 17.117188 7.070312 17.117188 Z M 7.070312 17.117188 " />
                        <path d="M 20.851562 17.117188 C 20.40625 17.117188 20.042969 17.480469 20.042969 17.929688 C 20.042969 18.375 20.40625 18.738281 20.851562 18.738281 C 21.296875 18.738281 21.660156 18.375 21.660156 17.929688 C 21.660156 17.480469 21.296875 17.117188 20.851562 17.117188 Z M 20.851562 17.117188 " />
                        <path d="M 16.257812 15.449219 L 10.414062 15.449219 C 10.195312 15.449219 10.019531 15.625 10.019531 15.839844 C 10.019531 16.054688 10.195312 16.230469 10.414062 16.230469 L 16.257812 16.230469 C 16.472656 16.230469 16.648438 16.054688 16.648438 15.839844 C 16.648438 15.625 16.472656 15.449219 16.257812 15.449219 Z M 16.257812 15.449219 " />
                        <path d="M 6.238281 13.777344 L 1.226562 13.777344 C 1.011719 13.777344 0.835938 13.953125 0.835938 14.171875 C 0.835938 14.386719 1.011719 14.5625 1.226562 14.5625 L 6.238281 14.5625 C 6.453125 14.5625 6.628906 14.386719 6.628906 14.171875 C 6.628906 13.953125 6.453125 13.777344 6.238281 13.777344 Z M 6.238281 13.777344 " />
                        <path d="M 13.613281 8.464844 C 13.460938 8.3125 13.210938 8.3125 13.058594 8.464844 L 9.578125 11.945312 L 7.765625 10.136719 C 7.613281 9.984375 7.367188 9.984375 7.210938 10.136719 C 7.058594 10.289062 7.058594 10.535156 7.210938 10.6875 L 9.300781 12.777344 C 9.375 12.851562 9.476562 12.890625 9.578125 12.890625 C 9.675781 12.890625 9.777344 12.851562 9.855469 12.777344 L 13.613281 9.019531 C 13.765625 8.867188 13.765625 8.617188 13.613281 8.464844 Z M 13.613281 8.464844 " />
                      </g>
                    </svg>

                    <small class="text_tipo_beneficio"> Frete Grátis</small>
                  </div>

                  <div
                    v-if="item.tipo_beneficio === 'V'"
                    class="icon_tipo_beneficio"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="22pt"
                      height="22pt"
                      viewBox="0 0 25 25"
                      version="1.1"
                    >
                      <g id="surface1">
                        <path d="M 24.191406 3.757812 L 0.808594 3.757812 C 0.363281 3.757812 0 4.121094 0 4.566406 L 0 20.433594 C 0 20.878906 0.363281 21.242188 0.808594 21.242188 L 24.191406 21.242188 C 24.636719 21.242188 25 20.878906 25 20.433594 L 25 4.566406 C 25 4.121094 24.636719 3.757812 24.191406 3.757812 Z M 24.21875 17.117188 L 22.9375 17.117188 C 22.722656 17.117188 22.546875 17.292969 22.546875 17.511719 C 22.546875 17.726562 22.722656 17.902344 22.9375 17.902344 L 24.21875 17.902344 L 24.21875 18.789062 L 17.929688 18.789062 C 17.710938 18.789062 17.535156 18.964844 17.535156 19.179688 C 17.535156 19.398438 17.710938 19.570312 17.929688 19.570312 L 24.21875 19.570312 L 24.21875 20.433594 C 24.21875 20.449219 24.207031 20.460938 24.191406 20.460938 L 0.808594 20.460938 C 0.792969 20.460938 0.78125 20.449219 0.78125 20.433594 L 0.78125 19.570312 L 16.257812 19.570312 C 16.472656 19.570312 16.648438 19.398438 16.648438 19.179688 C 16.648438 18.964844 16.472656 18.789062 16.257812 18.789062 L 0.78125 18.789062 L 0.78125 17.902344 L 21.269531 17.902344 C 21.484375 17.902344 21.660156 17.726562 21.660156 17.511719 C 21.660156 17.292969 21.484375 17.117188 21.269531 17.117188 L 0.78125 17.117188 L 0.78125 16.230469 C 0.792969 16.230469 0.800781 16.230469 0.808594 16.230469 L 24.191406 16.230469 C 24.199219 16.230469 24.207031 16.230469 24.21875 16.230469 Z M 24.21875 15.421875 C 24.21875 15.4375 24.207031 15.449219 24.191406 15.449219 L 0.808594 15.449219 C 0.792969 15.449219 0.78125 15.4375 0.78125 15.421875 L 0.78125 4.566406 C 0.78125 4.550781 0.792969 4.539062 0.808594 4.539062 L 24.191406 4.539062 C 24.207031 4.539062 24.21875 4.550781 24.21875 4.566406 Z M 24.21875 15.421875 " />
                        <path d="M 22.9375 7.097656 C 22.234375 7.097656 21.660156 6.523438 21.660156 5.820312 C 21.660156 5.601562 21.484375 5.429688 21.269531 5.429688 L 16.675781 5.429688 C 16.460938 5.429688 16.285156 5.601562 16.285156 5.820312 C 16.285156 6.035156 16.457031 6.210938 16.675781 6.210938 L 20.914062 6.210938 C 21.074219 7.035156 21.722656 7.683594 22.546875 7.84375 L 22.546875 12.144531 C 21.722656 12.304688 21.074219 12.957031 20.914062 13.777344 L 16.675781 13.777344 C 16.460938 13.777344 16.285156 13.953125 16.285156 14.171875 C 16.285156 14.386719 16.460938 14.5625 16.675781 14.5625 L 21.269531 14.5625 C 21.484375 14.5625 21.660156 14.386719 21.660156 14.171875 C 21.660156 13.464844 22.234375 12.890625 22.9375 12.890625 C 23.15625 12.890625 23.328125 12.714844 23.328125 12.5 L 23.328125 7.488281 C 23.328125 7.273438 23.15625 7.097656 22.9375 7.097656 Z M 22.9375 7.097656 " />
                        <path d="M 8.324219 13.777344 L 4.085938 13.777344 C 3.925781 12.957031 3.277344 12.304688 2.453125 12.144531 L 2.453125 7.84375 C 3.277344 7.683594 3.925781 7.035156 4.085938 6.210938 L 8.324219 6.210938 C 8.539062 6.210938 8.714844 6.035156 8.714844 5.820312 C 8.714844 5.601562 8.539062 5.429688 8.324219 5.429688 L 3.730469 5.429688 C 3.515625 5.429688 3.339844 5.601562 3.339844 5.820312 C 3.339844 6.523438 2.765625 7.097656 2.0625 7.097656 C 1.84375 7.097656 1.671875 7.273438 1.671875 7.488281 L 1.671875 12.5 C 1.671875 12.714844 1.84375 12.890625 2.0625 12.890625 C 2.765625 12.890625 3.339844 13.464844 3.339844 14.171875 C 3.339844 14.386719 3.515625 14.5625 3.730469 14.5625 L 8.324219 14.5625 C 8.539062 14.5625 8.714844 14.386719 8.714844 14.171875 C 8.714844 13.953125 8.539062 13.777344 8.324219 13.777344 Z M 8.324219 13.777344 " />
                        <path d="M 12.5 5.429688 C 9.980469 5.429688 7.933594 7.476562 7.933594 9.996094 C 7.933594 12.511719 9.980469 14.5625 12.5 14.5625 C 15.019531 14.5625 17.066406 12.511719 17.066406 9.996094 C 17.066406 7.476562 15.019531 5.429688 12.5 5.429688 Z M 12.5 13.777344 C 10.414062 13.777344 8.714844 12.082031 8.714844 9.996094 C 8.714844 7.910156 10.414062 6.210938 12.5 6.210938 C 14.585938 6.210938 16.285156 7.910156 16.285156 9.996094 C 16.285156 12.082031 14.585938 13.777344 12.5 13.777344 Z M 12.5 13.777344 " />
                        <path d="M 12.890625 9.695312 L 12.890625 8.328125 C 13.449219 8.414062 13.777344 8.667969 13.777344 8.820312 C 13.777344 9.035156 13.953125 9.210938 14.171875 9.210938 C 14.386719 9.210938 14.5625 9.035156 14.5625 8.820312 C 14.5625 8.160156 13.867188 7.648438 12.890625 7.539062 L 12.890625 7.488281 C 12.890625 7.273438 12.714844 7.097656 12.5 7.097656 C 12.285156 7.097656 12.109375 7.273438 12.109375 7.488281 L 12.109375 7.539062 C 11.132812 7.648438 10.4375 8.160156 10.4375 8.820312 C 10.4375 9.738281 11.355469 10.085938 12.109375 10.296875 L 12.109375 11.660156 C 11.550781 11.574219 11.222656 11.320312 11.222656 11.167969 C 11.222656 10.953125 11.046875 10.777344 10.828125 10.777344 C 10.613281 10.777344 10.4375 10.953125 10.4375 11.167969 C 10.4375 11.828125 11.132812 12.34375 12.109375 12.453125 L 12.109375 12.5 C 12.109375 12.714844 12.285156 12.890625 12.5 12.890625 C 12.714844 12.890625 12.890625 12.714844 12.890625 12.5 L 12.890625 12.453125 C 13.867188 12.34375 14.5625 11.828125 14.5625 11.167969 C 14.5625 10.25 13.644531 9.902344 12.890625 9.695312 Z M 12.109375 9.476562 C 11.457031 9.273438 11.222656 9.089844 11.222656 8.820312 C 11.222656 8.667969 11.550781 8.414062 12.109375 8.328125 Z M 12.890625 11.660156 L 12.890625 10.511719 C 13.542969 10.71875 13.777344 10.902344 13.777344 11.167969 C 13.777344 11.320312 13.449219 11.574219 12.890625 11.660156 Z M 12.890625 11.660156 " />
                      </g>
                    </svg>

                    <small class="text_tipo_beneficio"> R$ de desconto</small>
                  </div>

                  <div
                    v-if="item.tipo_beneficio === 'P'"
                    class="icon_tipo_beneficio"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="22pt"
                      height="22pt"
                      viewBox="0 0 25 25"
                      version="1.1"
                    >
                      <g id="surface1">
                        <path d="M 24.191406 5.429688 L 18.761719 5.429688 C 18.546875 5.429688 18.371094 5.601562 18.371094 5.820312 L 18.371094 6.238281 C 18.371094 6.480469 18.171875 6.679688 17.929688 6.679688 C 17.683594 6.679688 17.484375 6.480469 17.484375 6.238281 L 17.484375 5.820312 C 17.484375 5.601562 17.308594 5.429688 17.09375 5.429688 L 0.808594 5.429688 C 0.363281 5.429688 0 5.789062 0 6.238281 L 0 18.761719 C 0 19.210938 0.363281 19.570312 0.808594 19.570312 L 17.09375 19.570312 C 17.308594 19.570312 17.484375 19.398438 17.484375 19.179688 L 17.484375 18.761719 C 17.484375 18.519531 17.683594 18.320312 17.929688 18.320312 C 18.171875 18.320312 18.371094 18.519531 18.371094 18.761719 L 18.371094 19.179688 C 18.371094 19.398438 18.546875 19.570312 18.761719 19.570312 L 24.191406 19.570312 C 24.636719 19.570312 25 19.210938 25 18.761719 L 25 6.238281 C 25 5.789062 24.636719 5.429688 24.191406 5.429688 Z M 24.21875 18.761719 C 24.21875 18.777344 24.207031 18.789062 24.191406 18.789062 L 19.15625 18.789062 L 19.15625 18.761719 C 19.15625 18.222656 18.804688 17.765625 18.320312 17.601562 L 18.320312 17.09375 C 18.320312 16.875 18.144531 16.703125 17.929688 16.703125 C 17.710938 16.703125 17.535156 16.875 17.535156 17.09375 L 17.535156 17.601562 C 17.050781 17.765625 16.703125 18.222656 16.703125 18.761719 L 16.703125 18.789062 L 0.808594 18.789062 C 0.792969 18.789062 0.78125 18.777344 0.78125 18.761719 L 0.78125 6.238281 C 0.78125 6.222656 0.792969 6.210938 0.808594 6.210938 L 16.703125 6.210938 L 16.703125 6.238281 C 16.703125 6.777344 17.050781 7.234375 17.535156 7.398438 L 17.535156 7.90625 C 17.535156 8.125 17.710938 8.296875 17.929688 8.296875 C 18.144531 8.296875 18.320312 8.125 18.320312 7.90625 L 18.320312 7.398438 C 18.804688 7.234375 19.15625 6.777344 19.15625 6.238281 L 19.15625 6.210938 L 24.191406 6.210938 C 24.207031 6.210938 24.21875 6.222656 24.21875 6.238281 Z M 24.21875 18.761719 " />
                        <path d="M 17.929688 9.1875 C 17.710938 9.1875 17.535156 9.359375 17.535156 9.578125 L 17.535156 10.414062 C 17.535156 10.628906 17.710938 10.804688 17.929688 10.804688 C 18.144531 10.804688 18.320312 10.628906 18.320312 10.414062 L 18.320312 9.578125 C 18.320312 9.359375 18.144531 9.1875 17.929688 9.1875 Z M 17.929688 9.1875 " />
                        <path d="M 17.929688 11.691406 C 17.710938 11.691406 17.535156 11.867188 17.535156 12.082031 L 17.535156 12.917969 C 17.535156 13.132812 17.710938 13.308594 17.929688 13.308594 C 18.144531 13.308594 18.320312 13.132812 18.320312 12.917969 L 18.320312 12.082031 C 18.320312 11.867188 18.144531 11.691406 17.929688 11.691406 Z M 17.929688 11.691406 " />
                        <path d="M 17.929688 14.195312 C 17.710938 14.195312 17.535156 14.371094 17.535156 14.585938 L 17.535156 15.421875 C 17.535156 15.640625 17.710938 15.8125 17.929688 15.8125 C 18.144531 15.8125 18.320312 15.640625 18.320312 15.421875 L 18.320312 14.585938 C 18.320312 14.371094 18.144531 14.195312 17.929688 14.195312 Z M 17.929688 14.195312 " />
                        <path d="M 12.777344 8.464844 C 12.625 8.3125 12.375 8.3125 12.222656 8.464844 L 4.707031 15.980469 C 4.554688 16.132812 4.554688 16.382812 4.707031 16.535156 C 4.785156 16.609375 4.882812 16.648438 4.984375 16.648438 C 5.085938 16.648438 5.183594 16.609375 5.261719 16.535156 L 12.777344 9.019531 C 12.929688 8.867188 12.929688 8.617188 12.777344 8.464844 Z M 12.777344 8.464844 " />
                        <path d="M 6.238281 7.933594 C 5.101562 7.933594 4.175781 8.859375 4.175781 9.996094 C 4.175781 11.132812 5.101562 12.054688 6.238281 12.054688 C 7.375 12.054688 8.296875 11.132812 8.296875 9.996094 C 8.296875 8.859375 7.375 7.933594 6.238281 7.933594 Z M 6.238281 11.273438 C 5.53125 11.273438 4.957031 10.699219 4.957031 9.996094 C 4.957031 9.289062 5.53125 8.714844 6.238281 8.714844 C 6.941406 8.714844 7.515625 9.289062 7.515625 9.996094 C 7.515625 10.699219 6.941406 11.273438 6.238281 11.273438 Z M 6.238281 11.273438 " />
                        <path d="M 11.246094 12.945312 C 10.109375 12.945312 9.1875 13.867188 9.1875 15.003906 C 9.1875 16.140625 10.109375 17.066406 11.246094 17.066406 C 12.382812 17.066406 13.308594 16.140625 13.308594 15.003906 C 13.308594 13.867188 12.382812 12.945312 11.246094 12.945312 Z M 11.246094 16.285156 C 10.542969 16.285156 9.96875 15.710938 9.96875 15.003906 C 9.96875 14.300781 10.542969 13.726562 11.246094 13.726562 C 11.953125 13.726562 12.527344 14.300781 12.527344 15.003906 C 12.527344 15.710938 11.953125 16.285156 11.246094 16.285156 Z M 11.246094 16.285156 " />
                      </g>
                    </svg>

                    <small class="text_tipo_beneficio"> % de desconto</small>
                  </div>
                </div>
                <div class="float-right">
                  <div
                    v-if="item.verificado"
                    class="verificado"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="19pt"
                      height="19pt"
                      viewBox="0 0 19 19"
                      version="1.1"
                    >
                      <title>Item Verificado</title>
                      <g id="surface1">
                        <path d="M 19 9.5 L 16.847656 7.113281 L 17.1875 3.914062 L 14.039062 3.25 L 12.4375 0.460938 L 9.5 1.773438 L 6.5625 0.460938 L 4.960938 3.25 L 1.8125 3.914062 L 2.152344 7.113281 L 0 9.5 L 2.152344 11.886719 L 1.8125 15.085938 L 4.960938 15.75 L 6.5625 18.539062 L 9.5 17.226562 L 12.4375 18.539062 L 14.039062 15.75 L 17.1875 15.085938 L 16.847656 11.886719 Z M 13.484375 7.417969 L 8.714844 12.761719 L 5.398438 9.449219 L 6.1875 8.660156 L 8.667969 11.140625 L 12.652344 6.675781 Z M 13.484375 7.417969 " />
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="product-img_block">
                <a class="product-img">
                  <img
                    :src="item.logo"
                    :alt="item.titulo"
                  >
                </a>
              </div>
              <div class="product-info_block border-0">
                <h5
                  class="custom-item-type mb-0"
                  v-text="item.nome"
                ></h5>
<!--                <h5-->
<!--                  class="custom-item-type"-->
<!--                  v-text="item.nome_categoria"-->
<!--                ></h5>-->
                <h3
                  :class="customItemTitleClass"
                  v-text="item.titulo"
                ></h3>
                <p
                  class="product-describe"
                  v-text="item.descricao"
                ></p>
              </div>
              <div class="product-select">
                <button class="add-to-wishlist round-icon-btn">
                  <i class="icon_heart_alt"></i>
                </button>
                <button class="add-to-cart round-icon-btn">
                  <i class="icon_bag_alt"></i>
                </button>
                <button class="add-to-compare round-icon-btn">
                  <i class="fas fa-random"></i>
                </button>
                <button class="quickview round-icon-btn">
                  <i class="far fa-eye"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import MixingFunctions from '../MixingFunctions';
import QuickView from './QuickView';

export default {
    mixins: [
        MixingFunctions
    ],
    components: {
        QuickView
    },
    props: {
        // 18/09/2026: texto "Exibindo x a y de z" do cabecalho
        exibindo: {
            type: String,
            default: ''
        },
        customItemTitleClass: {
            type: String,
            default: 'custom-item-title'
        },
        showTitle: {
            type: Boolean,
            default: true
        },
        showListViewType: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: 'Shop Grid 03 Col'
        },
        fields: {
            type: Array,
            required: true
        },
        loadOnStart: {
            type: Boolean,
            default: true
        },
        apiUrl: {
            type: String,
            default: ''
        },
        httpMethod: {
            type: String,
            default: 'get',
            validator: (value) => {
                return ['get', 'post'].indexOf(value) > -1;
            }
        },
        reactiveApiUrl: {
            type: Boolean,
            default: true
        },
        apiMode: {
            type: Boolean,
            default: true
        },
        data: {
            type: [Array, Object],
            default: null
        },
        dataTotal: {
            type: Number,
            default: 0
        },
        dataManager: {
            type: Function,
            default: null
        },
        dataPath: {
            type: String,
            default: 'data'
        },
        paginationPath: {
            type: [String],
            default: 'links.pagination'
        },
        queryParams: {
            type: [Object, Function],
            default () {
                return {
                    sort: 'sort',
                    page: 'page',
                    perPage: 'per_page'
                };
            }
        },
        appendParams: {
            type: Object,
            default () {
                return {};
            }
        },
        httpOptions: {
            type: Object,
            default () {
                return {};
            }
        },
        httpFetch: {
            type: Function,
            default: null
        },
        perPage: {
            type: Number,
            default: 21
        },
        initialPage: {
            type: Number,
            default: 1
        },
        sortOrder: {
            type: Array,
            default () {
                return [];
            }
        },
        multiSort: {
            type: Boolean,
            default () {
                return false;
            }
        },
        tableHeight: {
            type: String,
            default: null
        },
        /*
         * physical key that will trigger multi-sort option
         * possible values: 'alt', 'ctrl', 'meta', 'shift'
         * 'ctrl' might not work as expected on Mac
         */
        multiSortKey: {
            type: String,
            default: 'alt'
        },
        /* deprecated */
        rowClassCallback: {
            type: [String, Function],
            default: ''
        },
        rowClass: {
            type: [String, Function],
            default: ''
        },
        detailRowComponent: {
            type: String,
            default: ''
        },
        detailRowTransition: {
            type: String,
            default: ''
        },
        trackBy: {
            type: String,
            default: 'id'
        },
        css: {
            type: Object,
            default () {
                return {
                    tableClass: 'ui blue selectable celled stackable attached table',
                    loadingClass: 'loading',
                    ascendingIcon: 'blue chevron up icon',
                    descendingIcon: 'blue chevron down icon',
                    ascendingClass: 'sorted-asc',
                    descendingClass: 'sorted-desc',
                    sortableIcon: '',
                    detailRowClass: 'vuetable-detail-row',
                    handleIcon: 'grey sidebar icon',
                    tableBodyClass: 'vuetable-semantic-no-top vuetable-fixed-layout',
                    tableHeaderClass: 'vuetable-fixed-layout'
                };
            }
        },
        minRows: {
            type: Number,
            default: 0
        },
        silent: {
            type: Boolean,
            default: false
        },
        noDataTemplate: {
            type: String,
            default () {
                return 'No Data Available';
            }
        },
        showSortIcons: {
            type: Boolean,
            default: true
        },
        fullLink: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            eventPrefix: 'vuetable:',
            tableFields: [],
            tableData: null,
            tablePagination: null,
            currentPage: this.initialPage,
            selectedTo: [],
            visibleDetailRows: [],
            lastScrollPosition: 0,
            scrollBarWidth: '17px', //chrome default
            scrollVisible: false,
            quickViewItem: {}
        };
    },
    mounted () {
        this.normalizeFields();
        this.normalizeSortOrder();
        if (this.isFixedHeader) {
            this.scrollBarWidth = this.getScrollBarWidth() + 'px';
        }
        this.$nextTick(function () {
            this.fireEvent('initialized', this.tableFields);
        });

        if (this.loadOnStart) {
            this.loadData();
        }
        if (this.isFixedHeader) {
            let elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
            if (elem != null) {
                elem.addEventListener('scroll', this.handleScroll);
            }
        }
    },
    destroyed () {
        let elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
        if (elem != null) {
            elem.removeEventListener('scroll', this.handleScroll);
        }
    },
    computed: {
        version: () => VERSION,
        useDetailRow () {
            if (this.tableData && this.tableData[0] && this.detailRowComponent !== '' && typeof this.tableData[0][this.trackBy] === 'undefined') {
                this.warn('You need to define unique row identifier in order for detail-row feature to work. Use `track-by` prop to define one!');
                return false;
            }

            return this.detailRowComponent !== '';
        },
        countVisibleFields () {
            return this.tableFields.filter(function (field) {
                return field.visible;
            }).length;
        },
        countTableData () {
            if (this.tableData === null) {
                return 0;
            }
            return this.tableData.length;
        },
        displayEmptyDataRow () {
            return this.countTableData === 0 && this.noDataTemplate.length > 0;
        },
        lessThanMinRows () {
            if (this.tableData === null || this.tableData.length === 0) {
                return true;
            }
            return this.tableData.length < this.minRows;
        },
        blankRows () {
            if (this.tableData === null || this.tableData.length === 0) {
                return this.minRows;
            }
            if (this.tableData.length >= this.minRows) {
                return 0;
            }

            return this.minRows - this.tableData.length;
        },
        isApiMode () {
            return this.apiMode;
        },
        isDataMode () {
            return ! this.apiMode;
        },
        isFixedHeader () {
            return this.tableHeight != null;
        }
    },
    methods: {
        getScrollBarWidth () {
            const outer = document.createElement('div'),
                inner = document.createElement('div');

            outer.style.visibility = 'hidden';
            outer.style.width = '100px';

            inner.style.width = '100%';


            outer.appendChild(inner);
            document.body.appendChild(outer);


            const widthWithoutScrollbar = outer.offsetWidth;

            outer.style.overflow = 'scroll';

            const widthWithScrollbar = inner.offsetWidth;


            document.body.removeChild(outer);


            return (widthWithoutScrollbar - widthWithScrollbar);
        },
        handleScroll (e) { //make sure that the header and the body are aligned when scrolling horizontally on a table that is wider than the viewport
            let horizontal = e.currentTarget.scrollLeft;
            if (horizontal != this.lastScrollPosition) { //don't modify header scroll if we are scrolling vertically
                let header = this.$el.getElementsByClassName('vuetable-head-wrapper')[0];
                if (header != null) {
                    header.scrollLeft = horizontal;
                }
                this.lastScrollPosition = horizontal;
            }
        },
        normalizeFields () {
            if (typeof(this.fields) === 'undefined') {
                this.warn('You need to provide "fields" prop.');
                return;
            }

            this.tableFields = [];
            let self = this,
                obj;
            this.fields.forEach(function (field, i) {
                if (typeof (field) === 'string') {
                    obj = {
                        name: field,
                        title: self.setTitle(field),
                        titleClass: '',
                        dataClass: '',
                        callback: null,
                        visible: true
                    };
                } else {
                    obj = {
                        name: field.name,
                        width: field.width,
                        title: (field.title === undefined) ? self.setTitle(field.name) : field.title,
                        sortField: field.sortField,
                        titleClass: (field.titleClass === undefined) ? '' : field.titleClass,
                        dataClass: (field.dataClass === undefined) ? '' : field.dataClass,
                        callback: (field.callback === undefined) ? '' : field.callback,
                        visible: (field.visible === undefined) ? true : field.visible
                    };
                }
                self.tableFields.push(obj);
            });
        },
        setData (data) {
            if (data === null || typeof(data) === 'undefined') return;

            this.fireEvent('loading');

            if (Array.isArray(data)) {
                this.tableData = data;
                this.fireEvent('loaded');
                return;
            }

            this.tableData = this.getObjectValue(data, this.dataPath, null);
            this.tablePagination = this.getObjectValue(data, this.paginationPath, null);

            this.$nextTick(function () {
                this.fixHeader();
                this.fireEvent('pagination-data', this.tablePagination);
                this.fireEvent('loaded');
            });
        },
        setTitle (str) {
            if (this.isSpecialField(str)) {
                return '';
            }

            return this.titleCase(str);
        },
        getTitle (field) {
            if (typeof(field.title) === 'function') return field.title();

            return typeof(field.title) === 'undefined'
                ? field.name.replace('.', ' ')
                : field.title;
        },
        renderTitle (field) {
            let title = this.getTitle(field);

            if (title.length > 0 && this.isInCurrentSortGroup(field) || this.hasSortableIcon(field)) {
                let style = `opacity:${this.sortIconOpacity(field)};position:relative;float:right`,
                    iconTag = this.showSortIcons ? this.renderIconTag(['sort-icon', this.sortIcon(field)], `style="${style}"`) : '';
                return title + ' ' + iconTag;
            }

            return title;
        },
        renderSequence (index) {
            return this.tablePagination
                ? this.tablePagination.from + index
                : index;
        },
        renderNormalField (field, item) {
            return this.hasCallback(field)
                ? this.callCallback(field, item)
                : this.getObjectValue(item, field.name, '');
        },
        isSpecialField (fieldName) {
            return fieldName.slice(0, 2) === '__';
        },
        titleCase (str) {
            return str.replace(/\w+/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        },
        camelCase (str, delimiter = '_') {
            let self = this;
            return str.split(delimiter).map(function (item) {
                return self.titleCase(item);
            }).join('');
        },
        notIn (str, arr) {
            return arr.indexOf(str) === -1;
        },
        loadData (success = this.loadSuccess, failed = this.loadFailed) {
            if (this.isDataMode) {
                this.callDataManager();
                return;
            }

            this.fireEvent('loading');

            this.httpOptions['params'] = this.getAppendParams(this.getAllQueryParams());

            return this.fetch(this.apiUrl, this.httpOptions).then(
                success,
                failed
            ).catch(() => failed());
        },
        fetch (apiUrl, httpOptions) {
            return this.httpFetch
                ? this.httpFetch(apiUrl, httpOptions)
                : axios[this.httpMethod](apiUrl, httpOptions);
        },
        loadSuccess (response) {
            this.fireEvent('load-success', response);

            let body = this.transform(response.data);

            this.tableData = this.getObjectValue(body, this.dataPath, null);
            this.tablePagination = this.getObjectValue(body, this.paginationPath, null);

            if (this.tablePagination === null) {
                this.warn('vuetable: pagination-path "' + this.paginationPath + '" not found. '
                    + 'It looks like the data returned from the sever does not have pagination information '
                    + 'or you may have set it incorrectly.\n'
                    + 'You can explicitly suppress this warning by setting pagination-path="".'
                );
            }

            this.$nextTick(function () {
                this.fixHeader();
                this.fireEvent('pagination-data', this.tablePagination);
                this.fireEvent('loaded');
            });
        },
        fixHeader () {
            if (!this.isFixedHeader) {
                return;
            }

            let elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
            if (elem != null) {
                if (elem.scrollHeight > elem.clientHeight) {
                    this.scrollVisible = true;
                }
                else {
                    this.scrollVisible = false;
                }
            }
        },
        loadFailed (response) {
            console.error('load-error', response);
            this.fireEvent('load-error', response);
            this.fireEvent('loaded');
        },
        transform (data) {
            let func = 'transform';

            if (this.parentFunctionExists(func)) {
                return this.$parent[func].call(this.$parent, data);
            }

            return data;
        },
        parentFunctionExists (func) {
            return (func !== '' && typeof this.$parent[func] === 'function');
        },
        callParentFunction (func, args, defaultValue = null) {
            if (this.parentFunctionExists(func)) {
                return this.$parent[func].call(this.$parent, args);
            }

            return defaultValue;
        },
        fireEvent (eventName, args) {
            this.$emit(this.eventPrefix + eventName, args);
        },
        warn (msg) {
            if (!this.silent) {
                console.warn(msg);
            }
        },
        getAllQueryParams () {
            let params = {};

            if (typeof(this.queryParams) === 'function') {
                params = this.queryParams(this.sortOrder, this.currentPage, this.perPage);
                return typeof(params) !== 'object' ? {} : params;
            }

            params[this.queryParams.sort] = this.getSortParam();
            params[this.queryParams.page] = this.currentPage;
            params[this.queryParams.perPage] = this.perPage;

            return params;
        },
        getSortParam () {
            if (!this.sortOrder || this.sortOrder.field == '') {
                return '';
            }

            if (typeof this.$parent['getSortParam'] === 'function') {
                return this.$parent['getSortParam'].call(this.$parent, this.sortOrder);
            }

            return this.getDefaultSortParam();
        },
        getDefaultSortParam () {
            let result = '';

            for (let i = 0; i < this.sortOrder.length; i++) {
                let fieldName = (typeof this.sortOrder[i].sortField === 'undefined')
                    ? this.sortOrder[i].field
                    : this.sortOrder[i].sortField;

                result += fieldName + '|' + this.sortOrder[i].direction + ((i+1) < this.sortOrder.length ? ',' : '');
            }
            return result;
        },
        getAppendParams (params) {
            for (let x in this.appendParams) {
                params[x] = this.appendParams[x];
            }

            return params;
        },
        extractName (string) {
            return string.split(':')[0].trim();
        },
        extractArgs (string) {
            return string.split(':')[1];
        },
        isSortable (field) {
            return !(typeof field.sortField === 'undefined');
        },
        isInCurrentSortGroup (field) {
            return this.currentSortOrderPosition(field) !== false;
        },
        hasSortableIcon (field) {
            return this.isSortable(field) && this.css.sortableIcon != '';
        },
        currentSortOrderPosition (field) {
            if (! this.isSortable(field)) {
                return false;
            }

            for (let i = 0; i < this.sortOrder.length; i++) {
                if (this.fieldIsInSortOrderPosition(field, i)) {
                    return i;
                }
            }

            return false;
        },
        fieldIsInSortOrderPosition (field, i) {
            return this.sortOrder[i].field === field.name && this.sortOrder[i].sortField === field.sortField;
        },
        orderBy (field, event) {
            if (! this.isSortable(field)) return;

            let key = this.multiSortKey.toLowerCase() + 'Key';

            if (this.multiSort && event[key]) { //adding column to multisort
                this.multiColumnSort(field);
            } else {
                //no multisort, or resetting sort
                this.singleColumnSort(field);
            }

            this.currentPage = 1;    // reset page index
            if (this.apiMode || this.dataManager) {
                this.loadData();
            }
        },
        multiColumnSort (field) {
            let i = this.currentSortOrderPosition(field);

            if (i === false) { //this field is not in the sort array yet
                this.sortOrder.push({
                    field: field.name,
                    sortField: field.sortField,
                    direction: 'asc'
                });
            } else { //this field is in the sort array, now we change its state
                if (this.sortOrder[i].direction === 'asc') {
                    // switch direction
                    this.sortOrder[i].direction = 'desc';
                } else {
                    //remove sort condition
                    this.sortOrder.splice(i, 1);
                }
            }
        },
        singleColumnSort (field) {
            if (this.sortOrder.length === 0) {
                this.clearSortOrder();
            }

            this.sortOrder.splice(1); //removes additional columns

            if (this.fieldIsInSortOrderPosition(field, 0)) {
                // change sort direction
                this.sortOrder[0].direction = this.sortOrder[0].direction === 'asc' ? 'desc' : 'asc';
            } else {
                // reset sort direction
                this.sortOrder[0].direction = 'asc';
            }
            this.sortOrder[0].field = field.name;
            this.sortOrder[0].sortField = field.sortField;
        },
        clearSortOrder () {
            this.sortOrder.push({
                field: '',
                sortField: '',
                direction: 'asc'
            });
        },
        sortClass (field) {
            let cls = '',
                i = this.currentSortOrderPosition(field);

            if (i !== false) {
                cls = (this.sortOrder[i].direction == 'asc') ? this.css.ascendingClass : this.css.descendingClass;
            }

            return cls;
        },
        sortIcon (field) {
            let cls = this.css.sortableIcon,
                i = this.currentSortOrderPosition(field);

            if (i !== false) {
                cls = (this.sortOrder[i].direction == 'asc') ? this.css.ascendingIcon : this.css.descendingIcon;
            }

            return cls;
        },
        sortIconOpacity (field) {
            /*
             * fields with stronger precedence have darker color
             *
             * if there are few fields, we go down by 0.3
             * ex. 2 fields are selected: 1.0, 0.7
             *
             * if there are more we go down evenly on the given spectrum
             * ex. 6 fields are selected: 1.0, 0.86, 0.72, 0.58, 0.44, 0.3
             */
            let max = 1.0,
                min = 0.3,
                step = 0.3,

                count = this.sortOrder.length,
                current = this.currentSortOrderPosition(field);


            if (max - count * step < min) {
                step = (max - min) / (count-1);
            }

            let opacity = max - current * step;

            return opacity;
        },
        hasCallback (item) {
            return item.callback ? true : false;
        },
        callCallback (field, item) {
            if (! this.hasCallback(field)) return;

            if (typeof(field.callback) == 'function') {
                return field.callback(this.getObjectValue(item, field.name));
            }

            let args = field.callback.split('|'),
                func = args.shift();

            if (typeof this.$parent[func] === 'function') {
                let value = this.getObjectValue(item, field.name);

                return (args.length > 0)
                    ? this.$parent[func].apply(this.$parent, [value].concat(args))
                    : this.$parent[func].call(this.$parent, value);
            }

            return null;
        },
        getObjectValue (object, path, defaultValue) {
            defaultValue = (typeof defaultValue === 'undefined') ? null : defaultValue;

            let obj = object;
            if (path.trim() != '') {
                let keys = path.split('.');
                keys.forEach(function (key) {
                    if (obj !== null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
                        obj = obj[key];
                    } else {
                        obj = defaultValue;
                        return;
                    }
                });
            }
            return obj;
        },
        toggleCheckbox (dataItem, fieldName, event) {
            let isChecked = event.target.checked,
                idColumn = this.trackBy;

            if (dataItem[idColumn] === undefined) {
                this.warn('__checkbox field: The "'+this.trackBy+'" field does not exist! Make sure the field you specify in "track-by" prop does exist.');
                return;
            }

            let key = dataItem[idColumn];
            if (isChecked) {
                this.selectId(key);
            } else {
                this.unselectId(key);
            }
            this.$emit('vuetable:checkbox-toggled', isChecked, dataItem);
        },
        selectId (key) {
            if (! this.isSelectedRow(key)) {
                this.selectedTo.push(key);
            }
        },
        unselectId (key) {
            this.selectedTo = this.selectedTo.filter(function (item) {
                return item !== key;
            });
        },
        isSelectedRow (key) {
            return this.selectedTo.indexOf(key) >= 0;
        },
        rowSelected (dataItem, fieldName) {
            let idColumn = this.trackBy,
                key = dataItem[idColumn];

            return this.isSelectedRow(key);
        },
        checkCheckboxesState (fieldName) {
            if (! this.tableData) return;

            let self = this,
                idColumn = this.trackBy,
                selector = 'th.vuetable-th-checkbox-' + idColumn + ' input[type=checkbox]',
                els = document.querySelectorAll(selector);

            //fixed:document.querySelectorAll return the typeof nodeList not array
            if (els.forEach===undefined)
                els.forEach=function (cb) {
                    [].forEach.call(els, cb);
                };

            // count how many checkbox row in the current page has been checked
            let selected = this.tableData.filter(function (item) {
                return self.selectedTo.indexOf(item[idColumn]) >= 0;
            });

            // count == 0, clear the checkbox
            if (selected.length <= 0) {
                els.forEach(function (el) {
                    el.indeterminate = false;
                });
                return false;
            }
            // count > 0 and count < perPage, set checkbox state to 'indeterminate'
            else if (selected.length < this.perPage) {
                els.forEach(function (el) {
                    el.indeterminate = true;
                });
                return true;
            }
            // count == perPage, set checkbox state to 'checked'
            else {
                els.forEach(function (el) {
                    el.indeterminate = false;
                });
                return true;
            }
        },
        toggleAllCheckboxes (fieldName, event) {
            let self = this,
                isChecked = event.target.checked,
                idColumn = this.trackBy;

            if (isChecked) {
                this.tableData.forEach(function (dataItem) {
                    self.selectId(dataItem[idColumn]);
                });
            } else {
                this.tableData.forEach(function (dataItem) {
                    self.unselectId(dataItem[idColumn]);
                });
            }
            this.$emit('vuetable:checkbox-toggled-all', isChecked);
        },
        gotoPreviousPage () {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.loadData();
            }
        },
        gotoNextPage () {
            if (this.currentPage < this.tablePagination.last_page) {
                this.currentPage++;
                this.loadData();
            }
        },
        gotoPage (page) {
            if (page != this.currentPage && (page > 0 && page <= this.tablePagination.last_page)) {
                this.currentPage = page;
                this.loadData();
            }
        },
        isVisibleDetailRow (rowId) {
            return this.visibleDetailRows.indexOf(rowId) >= 0;
        },
        showDetailRow (rowId) {
            if (!this.isVisibleDetailRow(rowId)) {
                this.visibleDetailRows.push(rowId);
            }
        },
        hideDetailRow (rowId) {
            if (this.isVisibleDetailRow(rowId)) {
                this.visibleDetailRows.splice(
                    this.visibleDetailRows.indexOf(rowId),
                    1
                );
            }
        },
        toggleDetailRow (rowId) {
            if (this.isVisibleDetailRow(rowId)) {
                this.hideDetailRow(rowId);
            } else {
                this.showDetailRow(rowId);
            }
        },
        showField (index) {
            if (index < 0 || index > this.tableFields.length) return;

            this.tableFields[index].visible = true;
        },
        hideField (index) {
            if (index < 0 || index > this.tableFields.length) return;

            this.tableFields[index].visible = false;
        },
        toggleField (index) {
            if (index < 0 || index > this.tableFields.length) return;

            this.tableFields[index].visible = ! this.tableFields[index].visible;
        },
        renderIconTag (classes, options = '') {
            return typeof(this.css.renderIcon) === 'undefined'
                ? `<i class="${classes.join(' ')}" ${options}></i>`
                : this.css.renderIcon(classes, options);
        },
        makePagination (total = null, perPage = null, currentPage = null) {
            let pagination = {};
            total = total === null ? this.dataTotal : total;
            perPage = perPage === null ? this.perPage : perPage;
            currentPage = currentPage === null ? this.currentPage : currentPage;

            return {
                total,
                'per_page': perPage,
                'current_page': currentPage,
                'last_page': Math.ceil(total / perPage) || 0,
                'next_page_url': '',
                'prev_page_url': '',
                'from': (currentPage -1) * perPage +1,
                'to': Math.min(currentPage * perPage, total)
            };
        },
        normalizeSortOrder () {
            this.sortOrder.forEach(function (item) {
                item.sortField = item.sortField || item.field;
            });
        },
        callDataManager () {
            if (this.dataManager === null && this.data === null) return;

            if (Array.isArray(this.data)) {
                return this.setData(this.data);
            }

            this.normalizeSortOrder();

            return this.setData(
                this.dataManager
                    ? this.dataManager(this.sortOrder, this.makePagination())
                    : this.data
            );
        },
        onRowClass (dataItem, index) {
            if (this.rowClassCallback !== '') {
                this.warn('"row-class-callback" prop is deprecated, please use "row-class" prop instead.');
                return;
            }

            if (typeof(this.rowClass) === 'function') {
                return this.rowClass(dataItem, index);
            }

            return this.rowClass;
        },
        onRowChanged (dataItem) {
            this.fireEvent('row-changed', dataItem);
            return true;
        },
        onRowClicked (dataItem, event) {
            this.$emit(this.eventPrefix + 'row-clicked', dataItem, event);
            return true;
        },
        onRowDoubleClicked (dataItem, event) {
            this.$emit(this.eventPrefix + 'row-dblclicked', dataItem, event);
        },
        onDetailRowClick (dataItem, event) {
            this.$emit(this.eventPrefix + 'detail-row-clicked', dataItem, event);
        },
        onCellClicked (dataItem, field, event) {
            this.$emit(this.eventPrefix + 'cell-clicked', dataItem, field, event);
        },
        onCellDoubleClicked (dataItem, field, event) {
            this.$emit(this.eventPrefix + 'cell-dblclicked', dataItem, field, event);
        },
        onCellRightClicked (dataItem, field, event) {
            this.$emit(this.eventPrefix + 'cell-rightclicked', dataItem, field, event);
        },
        /*
         * API for externals
         */
        changePage (page) {
            if (page === 'prev') {
                this.gotoPreviousPage();
            } else if (page === 'next') {
                this.gotoNextPage();
            } else {
                this.gotoPage(page);
            }
        },
        reload () {
            return this.loadData();
        },
        refresh () {
            this.currentPage = 1;
            return this.loadData();
        },
        resetData () {
            this.tableData = null;
            this.tablePagination = null;
            this.fireEvent('data-reset');
        },
        checkClick (item, index) {
            if (item !== '') {
                if (this.fullLink) {
                    window.location.href = item;
                    return;
                }
                this.$refs.quick[index].checkClick(item);
            }
        }
    }, // end: methods
    watch: {
        'multiSort' (newVal, oldVal) {
            if (newVal === false && this.sortOrder.length > 1) {
                this.sortOrder.splice(1);
                this.loadData();
            }
        },
        'apiUrl'  (newVal, oldVal) {
            if (this.reactiveApiUrl && newVal !== oldVal)
                this.refresh();
        },
        'data' (newVal, oldVal) {
            this.setData(newVal);
        },
        'tableHeight' (newVal, oldVal) {
            this.fixHeader();
        }
    }
};
</script>
